import { useMemo, useState } from "react";
import {
  InternalDashboardHeader,
  InternalDashoardTabs,
  KeyMetrics,
  UserActivity,
  Revenue,
} from "./components";
import { getHeaderTitle } from "./helpers";
import SupportTickets from "pages/support-tickets";
import styles from "./styles.module.scss";

export function InternalDashboard() {
  const [selectedTab, setSelectTab] = useState("key-matrics");
  const [activeSportType, setActiveSportType] = useState("golf");
  const [activePlateform, setActivePlateform] = useState("desktop");
  const [activeFeature, setActiveFeature] = useState("3d");

  const activeComponentObj: { [key: string]: JSX.Element } = useMemo(
    () => ({
      "key-matrics": (
        <KeyMetrics
          activeSportType={activeSportType}
          activePlateform={activePlateform}
          activeFeature={activeFeature}
        />
      ),
      "user-activity": (
        <UserActivity
          activeSportType={activeSportType}
          activePlateform={activePlateform}
          activeFeature={activeFeature}
        />
      ),
      revenue: <Revenue activePlateform={activePlateform} />,
      tickets: <SupportTickets />,
    }),
    [activeFeature, activePlateform, activeSportType]
  );

  const headerTitle = getHeaderTitle(selectedTab);
  const activeComponent = activeComponentObj[selectedTab] || <></>;

  return (
    <section
      style={{
        overflow: "auto",
      }}
      id="internal-dashboard"
      className={styles.internalDashboard}
    >
      <InternalDashboardHeader
        headerTitle={headerTitle}
        selectedTab={selectedTab}
        activeSportType={activeSportType}
        setActiveSportType={setActiveSportType}
        activePlateform={activePlateform}
        setActivePlateform={setActivePlateform}
        activeFeature={activeFeature}
        setActiveFeature={setActiveFeature}
      />

      <InternalDashoardTabs
        selectedTab={selectedTab}
        setSelectTab={setSelectTab}
      />

      {activeComponent}
    </section>
  );
}
